import { IClassroom } from "../../classrooms";
import { EntityTypes } from "../../EntityTypes";
import { IUser } from "../../users";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { FactoryType } from "../types";
import { IFactory } from "../types/IFactory";

export type IFactoryUpdateMutationParameters = {
    factory: RelationalValue<IFactory>;
    classrooms: RelationalValue<IClassroom>[];
    managers: RelationalValue<IUser>[];
    trainers: RelationalValue<IUser>[];
    type: FactoryType;
};

export type IFactoryUpdateMutationResult = IFactory;

export const factoryUpdateMutation: IApiMutationFunction<IFactoryUpdateMutationParameters> = ({
    factory,
    classrooms,
    managers,
    trainers,
    type,
}) => {
    return {
        method: "PUT",
        url: `/factories/${mapRelationalValue(factory)}`,
        data: {
            classrooms: classrooms.map(classroom => mapRelationalValueAsIRI(EntityTypes.CLASSROOM, classroom)),
            managers: managers.map(manager => mapRelationalValueAsIRI(EntityTypes.USER, manager)),
            trainers: trainers.map(trainer => mapRelationalValueAsIRI(EntityTypes.USER, trainer)),
            type,
        },
    };
};

export const useFactoryUpdateMutation = createApiMutationHook<
    IFactoryUpdateMutationParameters,
    IFactoryUpdateMutationResult
>(factoryUpdateMutation);
